import pdfMake from "pdfmake/build/pdfmake.js";
import getImage from "./GetImage";
import moment from "moment";
import { calculateAgeParse } from "../../../../Utils/Patient";

const yodoPDF = async (data) => {
  pdfMake.fonts = {
    Merriweather: {
      normal: "Merriweather-Regular.ttf",
      bold: "Merriweather-Bold.ttf",
      italics: "Merriweather-Italic.ttf",
      bolditalics: "Merriweather-ExtraBoldItalic.ttf",
    },
    Roboto: {
      normal: "Roboto-Regular.ttf",
      bold: "Roboto-Bold.ttf",
      italics: "Roboto-Italic.ttf",
      bolditalics: "Roboto-BoldItalic.ttf",
    },
  };

  const supportDoc = data.medicoApoyo[0];
  const lengthAdmissions = data.admissions.length;

  const header = {
    margin: [40, 10, 30, 0],
    layout: "noBorders",
    table: {
      widths: ["*", "*"],
      body: [
        [
          {
            image: await getImage(data.urlLogo),
            fit: [100, 40],
          },
          {
            text:
              data.profile.nombre +
              "\n Nit: " +
              data.profile.nit +
              "\n" +
              data.profile.direccion.direccion +
              " \n Teléfonos: " +
              data.profile.telefono1 +
              "-" +
              data.profile.telefono2,
            style: "head",
          },
        ],
      ],
    },
  };

  let docContent = [];

  const basicPatientInfo = () => {
    return {
      // auto-sized columns have their widths based on their content
      unbreakable: true,
      margin: [0, 10, 0, 10],
      layout: {
        defaultBorder: false,
      },
      table: {
        headerRows: 1,
        widths: ["auto", "auto", "auto", "auto"],
        body: [
          [
            {
              text: "Datos del Paciente",
              bold: true,
              style: "tableheader",
              border: [false, false, false, true],
              colSpan: 2,
            },
            "",
            {
              text: "Fecha:",
              style: "tableheader",
              bold: true,
              border: [false, false, false, true],
            },
            {
              text: moment(data.id_admision_actual.fecha).format("DD-MM-YYYY"),
              style: "textStyle",
              border: [false, false, false, true],
            },
          ],
          [
            { text: "Nombre: ", bold: true, style: "textStyle" },
            { text: data.names, style: "textStyle" },
            { text: "Identificación: ", bold: true, style: "textStyle" },
            {
              text: data.typeOfDocument + "-" + data.documentNumber,
              style: "textStyle",
            },
          ],
          [
            { text: "F. Nacimiento: ", bold: true, style: "textStyle" },
            {
              text: moment(data.birthday).format("DD-MM-YYYY"),
              style: "textStyle",
            },
            { text: "Edad ", bold: true, style: "textStyle" },
            { text: calculateAgeParse(data.birthday), style: "textStyle" },
          ],
          [
            { text: "Genero: ", bold: true, style: "textStyle" },
            { text: data.gender, style: "textStyle" },
            { text: "Dirección: ", bold: true, style: "textStyle" },
            { text: data.address, style: "textStyle" },
          ],
          [
            { text: "Ciudad: ", bold: true, style: "textStyle" },
            { text: data.city, style: "textStyle" },
            { text: "Tel/Cel: ", bold: true, style: "textStyle" },
            {
              text: data.telephone === null ||  data.telephone === undefined? "" : data.telephone + "/"
                + (data.cellphone === null || data.cellphone === undefined ? "" : data.cellphone),
              style: "textStyle",
            },
          ],
          [
            { text: "Entidad: ", bold: true, style: "textStyle" },
            { text: data.entity, style: "textStyle" },
            { text: "Regimen: ", bold: true, style: "textStyle" },
            { text: data.regimen, style: "textStyle" },
          ],
          [
            {
              text: "Examen: ",
              bold: true,
              style: "textStyle",
              border: [false, false, false, true],
            },
            {
              text: data.exam,
              style: "textStyle",
              border: [false, false, false, true],
            },
            {
              text: "Farmaco: ",
              bold: true,
              style: "textStyle",
              border: [false, false, false, true],
            },
            {
              text: data.nombre_medicamento,
              style: "textStyle",
              border: [false, false, false, true],
            },
          ],
        ],
      },
    };
  };

  docContent.push(basicPatientInfo());

  const ultimaAdmisionConDiagnostico = data.admissions.find((adm) => {
    return !!adm?.diagnostico;
  });

  let tableDiagnostics = [];

  if (ultimaAdmisionConDiagnostico) {
    const {
      diagnostico: {
        diagnostico: { diagnostico = [] },
      },
    } = ultimaAdmisionConDiagnostico;

    try {
      for (let k = 0; k < diagnostico.length; k++) {
        const element = diagnostico[k];
        tableDiagnostics.push([
          { text: "Diagnóstico:", bold: true, style: "textStyle" },
          { text: element.codigo + "  " + element.nombre, style: "textStyle" },
          "",
          "",
        ]);
      }
    } catch (error) {
      console.log(error);
    }
    if (diagnostico.length) {
      docContent.push({
        margin: [0, 0, 0, 10],
        layout: {
          defaultBorder: false,
        },
        table: {
          widths: ["auto", "*", "auto", "*"],
          headerRows: 1,
          body: tableDiagnostics,
        },
      });
    }
  }

  console.log("ultimaAdmisionConDiagnostico", ultimaAdmisionConDiagnostico);

  const dosis = () => {
    return {
      unbreakable: true,
      margin: [0, 3, 0, 3],
      layout: {
        defaultBorder: false,
      },
      table: {
        headerRows: 1,
        widths: ["auto", "*", "auto", "*"],
        body: [
          [
            { text: "Dosis:", bold: true, style: "textStyle" },
            { text: data.dosis_medicamento, style: "textStyle" },
            "",
            "",
          ],
        ],
      },
    };
  };

  docContent.push(dosis());

  const recomendaciones = () => {
    return {
      unbreakable: true,
      margin: [0, 10, 0, 10],
      layout: {
        defaultBorder: false,
      },
      table: {
        headerRows: 1,
        widths: ["auto", "*", "auto", "*"],
        body: [
          [
            {
              text: "Se administro terapia ablativa de Yodo   I-131 con las recomendaciones estrictas de aislamiento durante 5 a 7 días (habitación independiente) utensilios desechables de alimentación, el resto de recomendaciones estipuladas por la Agencia Internacional de Energía Atómica (AIEA) y con cita de control a los tres meses.",
              style: "tableheader",
            },
            "",
            "",
            "",
          ],
        ],
      },
    };
  };

  docContent.push(recomendaciones());

  if (ultimaAdmisionConDiagnostico) {
    let url_doctor =
      process.env.REACT_APP_PUBLIC_URL +
      ultimaAdmisionConDiagnostico.url_firma_doctor +
      "/" +
      sessionStorage.getItem("token");
    let url_medico_apoyo = supportDoc?.url_firma_doctor_alter
      ? process.env.REACT_APP_PUBLIC_URL +
        supportDoc.url_firma_doctor_alter +
        "/" +
        sessionStorage.getItem("token")
      : null;

    const columns = [];

    if (url_medico_apoyo) {
      columns.push({
        margin: [30, 30, 0, 0],
        layout: "headerLineOnly",
        table: {
          widths: [100],
          headerRows: 1,
          body: [
            [
              {
                image: await getImage(url_medico_apoyo),
                fit: [120, 70],
              },
            ],
            [
              {
                text: `Dr. ${supportDoc.nombres} ${supportDoc.apellido1} ${supportDoc.apellido2}\n${supportDoc.especialidad}\nREG-${supportDoc.reg_medico}`,
                style: "medicStyle",
              },
            ],
          ],
        },
      });
    }

    columns.push({
      margin: [30, 30, 0, 0],
      layout: "headerLineOnly",
      //border: [false, false, false, false],
      table: {
        widths: [100],
        headerRows: 1,
        body: [
          [
            {
              image: await getImage(url_doctor),
              fit: [120, 70],
            },
          ],
          [
            {
              text: `Dr. ${ultimaAdmisionConDiagnostico.nombres} ${ultimaAdmisionConDiagnostico.apellido1} ${ultimaAdmisionConDiagnostico.apellido2}\n${ultimaAdmisionConDiagnostico.especialidad}\nREG-${ultimaAdmisionConDiagnostico.reg_medico}`,
              style: "medicStyle",
            },
          ],
        ],
      },
    });

    docContent.push({
      columns,
      columnGap: 40,
    });
  }

  const docDefinition = {
    pageSize: "LETTER",
    pageOrientation: "portrait",
    header: header,
    pageMargins: [20, 50, 20, 20],
    defaultStyle: {
      fontSize: 8,
      alignment: "left",
    },
    content: docContent,
    styles: {
      header: {
        fontSize: 22,
        bold: true,
        font: "Roboto",
      },
      head: {
        fontSize: 7,
        bold: true,
        alignment: "left",
      },
      tableheader: {
        fontSize: 10,
      },
      textStyle: {
        fontSize: 9,
      },
      lineTittle: {
        fontSize: 10,
        bold: true,
        alignment: "left",
      },
      tableTexStyle: {
        fontSize: 8,
        alignment: "left",
      },
      foter: {
        alignment: "center",
        fontSize: 6,
      },
      medicStyle: {
        fontSize: 9,
        alignment: "center",
        bold: true,
        font: "Roboto",
      },
    },
  };

  const pdfDocGenerator = pdfMake.createPdf(docDefinition);
    pdfDocGenerator.getDataUrl(function (outDoc) {
      document.getElementById("pdfV").src = outDoc;
    });
  
};

export default yodoPDF;
